import {gql} from '@apollo/client';

export const logsQueries = {
    ALL_LOGS_BY_OBJECT_ID_AND_OBJECT_TYPE: gql`
        query AllLogsByObjectIdAndObjectType(
            $type: LOGS_CONFIG_ENUM!
            $objectId: UUID!
            $objectType: LOGS_OBJECT_TYPE!
            $after: String
            $first: Int
            $before: String
            $last: Int
        ) {
            allLogsByObjectIdAndObjectType(
                type: $type
                objectId: $objectId
                objectType: $objectType
                after: $after
                first: $first
                before: $before
                last: $last
            ) {
                totalCount
                edges {
                    cursor
                }
                nodes {
                    data
                    date
                    event
                    id
                    objectId
                    objectType
                    requestType
                    responseTime
                    type
                    url
                    userId
                }
                pageInfo {
                    endCursor
                    hasNextPage
                    hasPreviousPage
                    startCursor
                }
            }
        }
    `,
    FIRST_LOG_BY_OBJECT_ID_AND_OBJECT_TYPE: gql`
        query FirstLogByObjectIdAndObjectType(
            $type: LOGS_CONFIG_ENUM!
            $objectId: UUID!
            $objectType: LOGS_OBJECT_TYPE!
            $eventType: LOGS_EVENT_TYPE!
        ) {
            firstLogByObjectIdAndObjectType(
                type: $type
                objectId: $objectId
                objectType: $objectType
                eventType: $eventType
            ) {
                data
                date
                event
                id
                objectId
                objectType
                requestType
                responseTime
                type
                url
                userId
            }
        }
    `,
};
